"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const i18n_js_1 = __importDefault(require("i18n-js"));
const react_router_dom_1 = require("react-router-dom");
const material_1 = require("@mui/material");
const LocalPhone_1 = __importDefault(require("@mui/icons-material/LocalPhone"));
const LocationOn_1 = __importDefault(require("@mui/icons-material/LocationOn"));
const WebOutlined_1 = __importDefault(require("@mui/icons-material/WebOutlined"));
const withStore_1 = __importDefault(require("../../../../common/decorators/withStore"));
const globalVariables_1 = require("../../../../common/globalVariables");
const NUMBER_OF_ITEMS_IN_LIST = 3;
const MainImage = styled_components_1.default.div `
  height: 30vh;
  position: relative;

  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;

  background-image: ${props => `url(${props.Lpic} )`};

  @media (min-width: 600px) {
    background-image: ${props => `url(${props.XXLpic} )`};
  }
`;
const ContactPageWrapper = styled_components_1.default.div `
  display: grid;
  grid-template-rows: auto 1fr;
  min-width: auto;
  overflow: hidden;

  @media (min-width: 1000px) {
    min-width: ${props => props.minModalWidth}px;
    min-height: 300px;
    max-width: ${props => props.contentMaxWidth}px;
    margin: ${props => (props.isLoadedFromSettingPage ? 'initial' : '0 auto')};
  }

  .contact-list-container {
    background-color: #fff;
    border-radius: 20px;
    overflow: ${props => (props.numberOfItemsInList > NUMBER_OF_ITEMS_IN_LIST ? 'auto' : 'inset')};
    padding: 16px;
  }

  .image-container {
    display: ${props => (props.numberOfItemsInList > NUMBER_OF_ITEMS_IN_LIST ? 'none' : 'block')};
    max-height: 300px;
  }

  .image-container + .contact-list-container {
    top: ${props => (props.numberOfItemsInList > NUMBER_OF_ITEMS_IN_LIST ? '0' : '-25px')};
  }

  .MuiListItem-root {
    cursor: pointer;
    width: ${props => (props.isLoadedFromSettingPage ? 'fit-content' : 'auto')};
    padding-left: 0;
  }

  .list-item-icon {
    align-self: flex-start;
  }
`;
const StyledListItemText = (0, styled_components_1.default)(material_1.ListItemText) `
  margin: 0 0 0 10px;

  .MuiListItemText-primary {
    color: ${props => props.theme.palette.secondary.main};
    margin-bottom: 3px;
  }
`;
const ContactPage = (props) => {
    const { venue, history, location, isLoadedFromSettingPage, hotelView } = props;
    const [numberOfItemsInList, setNumberOfItemsInList] = (0, react_1.useState)(0);
    const venueAddressString = `${venue.address1 ? venue.address1 : ''} ${venue.address2 ? venue.address2 : ''}, ${venue.zip ? venue.zip : ''}, ${venue.city ? venue.city : ''}`;
    const showMap = () => {
        history.push({
            pathname: `${location.pathname}/map`,
            search: location.search,
        });
    };
    const call = number => {
        document.location.href = `tel:${number}`;
    };
    const renderPhoneNumbers = () => venue.phoneNumbers.map(phoneNumber => (react_1.default.createElement(material_1.ListItem, { key: Math.random(), onClick: () => call(phoneNumber.number) },
        react_1.default.createElement(LocalPhone_1.default, { htmlColor: "black", className: "list-item-icon" }),
        react_1.default.createElement(StyledListItemText, { primary: phoneNumber.label, secondary: phoneNumber.number }))));
    (0, react_1.useEffect)(() => {
        const ul = document.querySelector('.contact-list-container');
        if (!ul) {
            return;
        }
        const lis = Array.from(ul.children).filter(element => element.tagName === 'LI');
        setNumberOfItemsInList(lis.length);
    }, [numberOfItemsInList]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(MainImage, { Lpic: hotelView.L, XXLpic: hotelView.XXL }),
        react_1.default.createElement(ContactPageWrapper, { contentMaxWidth: globalVariables_1.WEB_APP.MAX_WIDTH_CONTAINER, minModalWidth: globalVariables_1.WEB_APP.MODAL_WIDTH, numberOfItemsInList: numberOfItemsInList, isLoadedFromSettingPage: isLoadedFromSettingPage },
            react_1.default.createElement(material_1.List, { className: "contact-list-container" },
                venue.address1 && (react_1.default.createElement(material_1.ListItem, { onClick: showMap },
                    react_1.default.createElement(LocationOn_1.default, { htmlColor: "black", className: "list-item-icon" }),
                    react_1.default.createElement(StyledListItemText, { primary: "Address", secondary: venueAddressString }))),
                renderPhoneNumbers(),
                venue.website && (react_1.default.createElement(material_1.ListItem, { onClick: () => window.open(venue.website, '_blank') },
                    react_1.default.createElement(WebOutlined_1.default, { htmlColor: "black", className: "list-item-icon" }),
                    react_1.default.createElement(StyledListItemText, { primary: i18n_js_1.default.t('website'), secondary: venue.website })))))));
};
const mapStoreToProps = store => ({
    hotelView: store.getValue('hotelView'),
    venue: store.getValue('venue'),
});
exports.default = (0, react_router_dom_1.withRouter)((0, withStore_1.default)(mapStoreToProps)(ContactPage));
